import { render, staticRenderFns } from "./Feeds.vue?vue&type=template&id=d7970986"
import script from "./Feeds.vue?vue&type=script&lang=js"
export * from "./Feeds.vue?vue&type=script&lang=js"
import style0 from "./Feeds.vue?vue&type=style&index=0&id=d7970986&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports